window.addEventListener('DOMContentLoaded', (event) => {
  // Wait until all elements in DOM are loaded (theme page:loaded not triggering)
  const sizeChartButton = document.querySelector('.dh_size-chart-button');
  //Check that sizechart button is present on page
  if (typeof sizeChartButton != 'undefined' && sizeChartButton != null){
    const formContainer = document.querySelector('.product-single__sticky.product-grid__content');

    //Apply logic to form container so that fixed sizechartmodal isn't restricted by parent position
    sizeChartButton.addEventListener('click', function(){
      if (formContainer.style.position != 'static') {
        formContainer.style.position = 'static';
      } else {
        formContainer.style.position = 'sticky';
      }
    })

  }
});